
import { getConfig } from '../../../utils'
import './style.css';

export async function openChartInfo(chart: 'string') {
    // fetch chart metadata based on chart type
    const chartsInfo = await getConfig('charts-info.json')
    const chartInfo = chartsInfo[chart]

    let content = `
        <h4>About chart</h4>
        <p>No information available</p>
    `;
    if (chartInfo) {
        content = `
        <h4>${chartInfo.title}</h4>
        <p>${chartInfo.description}</p>
        `;
    }
    showModal(content); // your modal implementation
}

let modalEl: HTMLDialogElement | null = null;

export function showModal(html: string) {
    if (!modalEl) {
        modalEl = document.createElement('dialog');
        modalEl.className = 'app-modal';

        modalEl.innerHTML = `
      <div class="app-modal__content">
        <button class="app-modal__close" aria-label="Close">×</button>
        <div class="app-modal__body"></div>
      </div>
    `;

        document.body.appendChild(modalEl);

        // Close handlers
        modalEl
            .querySelector('.app-modal__close')!
            .addEventListener('click', () => modalEl!.close());

        modalEl.addEventListener('click', e => {
            if (e.target === modalEl) modalEl!.close();
        });
    }

    modalEl.querySelector('.app-modal__body')!.innerHTML = html;
    modalEl.showModal();
}
